/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DBQueryParameterInput = {
    name: string;
    type: string;
    value?: string | null | undefined;
};
export type QuerySagasResultQueryVariables = {
    queryId?: number | null | undefined;
    parameters?: Array<DBQueryParameterInput | null> | null | undefined;
};
export type QuerySagasResultQueryResponse = {
    readonly queryResult: {
        readonly queryId: number | null;
        readonly columns: ReadonlyArray<string | null> | null;
        readonly rows: ReadonlyArray<{
            readonly rowId: number | null;
            readonly values: ReadonlyArray<string | null> | null;
        } | null> | null;
        readonly aggregationRow: ReadonlyArray<string | null> | null;
    } | null;
};
export type QuerySagasResultQuery = {
    readonly response: QuerySagasResultQueryResponse;
    readonly variables: QuerySagasResultQueryVariables;
};



/*
query QuerySagasResultQuery(
  $queryId: Int
  $parameters: [DBQueryParameterInput]
) {
  queryResult(queryId: $queryId, parameters: $parameters) {
    queryId
    columns
    rows {
      rowId
      values
    }
    aggregationRow
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parameters"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "parameters",
        "variableName": "parameters"
      },
      {
        "kind": "Variable",
        "name": "queryId",
        "variableName": "queryId"
      }
    ],
    "concreteType": "DBQueryResult",
    "kind": "LinkedField",
    "name": "queryResult",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "queryId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "columns",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DBQueryResultRow",
        "kind": "LinkedField",
        "name": "rows",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rowId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "values",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aggregationRow",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "QuerySagasResultQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "QuerySagasResultQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7f646cda89a6636734c67458dd0fdce1",
    "id": null,
    "metadata": {},
    "name": "QuerySagasResultQuery",
    "operationKind": "query",
    "text": "query QuerySagasResultQuery(\n  $queryId: Int\n  $parameters: [DBQueryParameterInput]\n) {\n  queryResult(queryId: $queryId, parameters: $parameters) {\n    queryId\n    columns\n    rows {\n      rowId\n      values\n    }\n    aggregationRow\n  }\n}\n"
  }
};
})();
(node as any).hash = '6b9e5f04da981b7e70377d44ecf31b53';
export default node;
